/* eslint-disable jsx-a11y/anchor-is-valid */

import React from 'react';
import { useTranslation } from 'react-i18next';
import { PaymentPlan as PaymentPlanType, PaymentPlanStatus, getCardStatusText, CardStatus } from './PatientDetailsConstant';
import EditIcon from '../../../../../assets/icons/icon-billing-edit.svg';
import PauseIcon from '../../../../../assets/icons/icon-billing-pause.svg';
import CancelIcon from '../../../../../assets/icons/icon-billing-close.svg';
import AddIcon from '../../../../../assets/icons/icon-add.svg';
import ActiveIcon from '../../../../../assets/icons/icon-billing-plan-active.svg';
import PausedIcon from '../../../../../assets/icons/icon-billing-pause-play.svg';
import FailedIcon from '../../../../../assets/icons/icon-billing-error.svg';
import YellowPause from '../../../../../assets/icons/icon-billing-yellow-pause.svg';
import { Spinner } from 'react-bootstrap';

interface PaymentPlanProps {
  paymentPlan: PaymentPlanType | null;
  clientID: string | undefined;
  onPause: (planId: string) => void;
  onResume: (planId: string) => void;
  onCreate: () => void;
  onDelete: (planId: string) => void;
  onEdit: (plan: PaymentPlanType) => void;
  isLoading: boolean;
}

const getPlanStatusDetails = (status: PaymentPlanStatus) => {

  switch (status) {
    case PaymentPlanStatus.ACTIVE:
      return { icon: ActiveIcon, className: 'active',text: PaymentPlanStatus.ACTIVE };
    case PaymentPlanStatus.PAUSED:
      return { icon: YellowPause, className: 'paused',text: PaymentPlanStatus.PAUSED };
    case PaymentPlanStatus.FAILED:
      return { icon: FailedIcon, className: 'failed',text: PaymentPlanStatus.FAILED };
    default:
      return { icon: ActiveIcon, className: 'active', text: PaymentPlanStatus.ACTIVE };
  }
};

const getCardStatusClass = (status: CardStatus) => {
  if (status === CardStatus.VALID_CARD) {
    return 'valid';
  }
   
  return 'invalid';
};

const  PaymentPlanDetails: React.FC<PaymentPlanProps> = ({ paymentPlan, onPause, onResume, onCreate, onDelete, onEdit, isLoading }) => {
  const { t } = useTranslation();
  const statusDetails = paymentPlan ? getPlanStatusDetails(paymentPlan.status) : null;
  
  return (
    <div className={`details-card payment-plan-card ${!paymentPlan ? 'justify-content-center':''}`}>
      {isLoading ? (
        <div className="loader-container">
          <Spinner animation="border" />
        </div>
      ) : (
        <>
          {paymentPlan && paymentPlan.status && <div className="card-header">
            <div className="title">
              {statusDetails && 
                <div className={`status-icon-wrapper ${statusDetails.className}`}>
                  <img src={statusDetails.icon} alt="status" className="status-icon" />
                </div>
              }
              {t('paymentPlanDetails.paymentPlan')} : <span className={`status-text ${statusDetails?.className}`}>{statusDetails?.text}</span>
            </div>
            <div className="actions">
              {paymentPlan?.status === PaymentPlanStatus.PAUSED ? (
                <>
                  <a href="#" className='auto-play' onClick={() => paymentPlan && onResume(paymentPlan.id)}><img src={PausedIcon} alt="play" /></a>
                  <a href="#" className="cancel" onClick={() => paymentPlan && onDelete(paymentPlan.id)}><img src={CancelIcon} alt="cancel" /></a>
                </>
              ) : (
                <>
                  <a href="#" onClick={() => paymentPlan && onEdit(paymentPlan)}><img src={EditIcon} alt="edit" /></a>
                  <a href="#" onClick={() => paymentPlan && onPause(paymentPlan.id)}><img src={PauseIcon} alt="pause" /></a>
                  <a href="#" className="cancel" onClick={() => paymentPlan && onDelete(paymentPlan.id)}><img src={CancelIcon} alt="cancel" /></a>
                </>
              )}
            </div>
          </div>}

          {paymentPlan && paymentPlan.status ? (
            <div className="plan-details">
              <div className="detail-item status-text">
                <div className="detail-label">{t('paymentPlanDetails.cardStatus')}</div>
                <div className={`detail-value ${getCardStatusClass(paymentPlan?.card_status)}`}>{getCardStatusText(paymentPlan?.card_status)}</div>
              </div>
              <div className="detail-item">
                <div className="detail-label">{t('paymentPlanDetails.chargeAmount')}</div>
                <div className="detail-value">${paymentPlan.paymentAmount}</div>
              </div>
              <div className="detail-item">
                <div className="detail-label">{t('paymentPlanDetails.frequency')}</div>
                <div className="detail-value">{paymentPlan.frequency}</div>
              </div>
              <div className="detail-item">
                <div className="detail-label">{t('paymentPlanDetails.lastChargeDate')}</div>
                <div className="detail-value">
                  {paymentPlan.last_payment_date ? new Date(paymentPlan.last_payment_date).toLocaleDateString():'-'}
                </div>
              </div>
              <div className="detail-item">
                <div className="detail-label">{t('paymentPlanDetails.nextChargeDate')}</div>
                <div className="detail-value">
                  {new Date(paymentPlan.nextPaymentDate).toLocaleDateString()}
                </div>
              </div>
            </div>
          ) : (
            <div className="plan-details">
              {paymentPlan?.card_status === CardStatus.VALID_CARD ? (
                <button className="create-payment-plan-btn" onClick={onCreate}>
                  <img src={AddIcon} alt="add" /><span style={{fontSize:"18px",marginRight:"10px",fontWeight:"600"}}>+</span> {t('paymentPlanDetails.createPaymentPlan')}
                </button>
              ) : paymentPlan?.card_status === CardStatus.NO_CARD ? (
                <div className="no-card-message">{t('paymentPlanDetails.noCardAvailable')}</div>
              ) : paymentPlan?.card_status === CardStatus.CONSENT_PENDING ? (
                <div className="no-card-message">{t('paymentPlanDetails.notAvailablePlan')}</div>
              ) : (
                <div className="no-card-message">{getCardStatusText(paymentPlan?.card_status)}</div>
              )}
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default PaymentPlanDetails;